import Loader from "components/shared/loader";
import React from "react";
import Buttons from "../buttons";
import Form from "./form";
import Show from "./show";

const Scenario = (props) => {
    const toggleEditMode = () => {
        const { scenario } = props;
        if (scenario.editMode) {
            props.resetScenario();
        } else {
            onChange({ name: "editMode", value: !scenario.editMode });
        }
    };

    const onChange = ({ name, value }) => {
        const { scenario } = props;
        scenario[name] = value;
        props.onChange({ name: "scenario", value: scenario });
    };

    const { scenario, questionOptions } = props;
    return (
        <div className="pb-2">
            {scenario.isLoading && (
                <div className="loader-snippet--disable-loader">
                    <Loader />
                </div>
            )}
            {scenario.editMode ? (
                <Form {...props} scenario={scenario} onChange={onChange} />
            ) : (
                <Show {...scenario} questionOptions={questionOptions} />
            )}
            <div className="pb-4 pt-2">
                <Buttons
                    type="scenario"
                    editMode={scenario.editMode}
                    toggleEditMode={toggleEditMode}
                    saveItem={props.saveScenario}
                    removeItem={props.removeScenario}
                    createCopy={props.createCopy}
                    hasDriverAnswers={props.hasDriverAnswers}
                />
            </div>
        </div>
    );
};

export default Scenario;
